module.exports = __webpack_public_path__ + "static/data_collection-b02377090eb402f67ebb0f6e636d97a8.jpg";